import React from "react";
import LegalPage from "@/components/LegalPage";

export default function Impressum() {
  return (
    <LegalPage
      title="Impressum"
      subtitle="Angaben gemäß § 5 TMG"
      lastUpdated="22. April 2026"
      testid="page-impressum"
    >
      <h2>Anbieter & Verantwortlicher</h2>
      <p>
        <strong>Easy Gutachter GmbH</strong><br />
        Im Mediapark 8<br />
        50670 Köln<br />
        Deutschland
      </p>

      <h2>Kontakt</h2>
      <p>
        Telefon: [+49 …]<br />
        E-Mail: <a href="mailto:hallo@easy-gutachter.de">hallo@easy-gutachter.de</a><br />
        Web: <a href="https://easy-gutachter.de">easy-gutachter.de</a>
      </p>

      <h2>Vertretungsberechtigte</h2>
      <p>Geschäftsführung: [Name(n) der Geschäftsführer]</p>

      <h2>Registereintrag</h2>
      <p>
        Eintragung im Handelsregister<br />
        Registergericht: [Ort]<br />
        Registernummer: HRB [Nummer]
      </p>

      <h2>Umsatzsteuer-ID</h2>
      <p>
        Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz: <strong>DE [Nummer]</strong>
      </p>

      <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
      <p>[Name der verantwortlichen Person]<br />[Adresse wie oben]</p>

      <h2>Haftungsausschluss</h2>
      <h3>Haftung für Inhalte</h3>
      <p>
        Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
        Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte
        oder gespeicherte fremde Informationen zu überwachen.
      </p>

      <h3>Haftung für Links</h3>
      <p>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb
        können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
      </p>

      <h3>Urheberrecht</h3>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke unterliegen dem deutschen Urheberrecht.
        Vervielfältigung, Bearbeitung, Verbreitung jeder Art bedürfen der schriftlichen Zustimmung des jeweiligen
        Autors bzw. Erstellers.
      </p>

      <h2>Streitschlichtung</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
        {" "}<a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer">ec.europa.eu/consumers/odr</a>.
        Wir sind nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </LegalPage>
  );
}
